export class ListAzureStorageAccountContainersRequest {
    'storageAccount';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "storageAccount",
            "baseName": "storageAccount",
            "type": "AzureStorageAccount",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListAzureStorageAccountContainersRequest.attributeTypeMap;
    }
    constructor() {
    }
}
